module.exports = __webpack_public_path__ + "static/media/thumbnail_uk.8553d886.png";